export default "__VITE_ASSET__hujd$NgO__"